import React from "react";
import {UnderlinedHeader, InfoPopover} from "../../components";
import {Checkbox} from "xps-react";
import {formatPercentWithTwoDecimals} from "../../utils/format";
import {useAppSelector} from "../../store/hooks";
import {selectReleaseToggles} from "../../ReleaseToggles/releaseTogglesSlice";

export function InflowCharacteristics(props: {
    isProfileWithProposalsOrArchived?: boolean,
    isInflowWillFundLifestyleGoal?: boolean,
    isHighRisk?: boolean,
    willAdjustWithInflation: boolean,
    isAdjustWithInflationCheckboxDisabled?: boolean,
    onFundLifestyleGoalChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    interestRate: number | undefined
}) {
    const releaseToggles = useAppSelector(selectReleaseToggles);
    const enableEnhancedLifestyleFunding = releaseToggles?.enableEnhancedLifestyleFunding ?? false;

    return <section>
        <UnderlinedHeader
            className="inflow-characteristics-section-header"
            primaryText="Inflow Characteristics"
        />
        {props.isInflowWillFundLifestyleGoal !== undefined &&
            <div className="layout-data-entry-form__field">
                {enableEnhancedLifestyleFunding ?
                    <>
                        <Checkbox
                            name="isInflowWillFundLifestyleGoal"
                            aria-label="Inflow will fund goals in year(s) received"
                            value="Inflow will fund goals in year(s) received"
                            checked={props.isInflowWillFundLifestyleGoal}
                            onChange={props.onFundLifestyleGoalChange}
                            disabled={props.isProfileWithProposalsOrArchived}
                        />
                        <InfoPopover
                            content={<div>If checked, the inflow will fund goals in the year(s) received. If unchecked, the inflow(s) will be saved for future use, funding goals only after investable assets have been depleted. Selection is disabled for <b>Distribution</b> and <b>Pro Rata</b>, as investable asset/inflow alignment has been pre-determined</div>}
                            direction="top"
                            width="376px"
                        />
                    </> :
                    <Checkbox
                        name="isInflowWillFundLifestyleGoal"
                        aria-label="Inflow will fund lifestyle goal"
                        value="Inflow will fund lifestyle goal"
                        checked={props.isInflowWillFundLifestyleGoal}
                        onChange={props.onFundLifestyleGoalChange}
                        disabled={props.isProfileWithProposalsOrArchived}
                    />}
            </div>}
        <div className="layout-data-entry-form__field">
            <Checkbox
                name="willAdjustWithInflation"
                aria-label="Inflow will adjust with inflation"
                value="Inflow will adjust with inflation"
                checked={props.willAdjustWithInflation}
                disabled={props.isAdjustWithInflationCheckboxDisabled || props.isProfileWithProposalsOrArchived}
                onChange={props.onChange}
            />
        </div>
        <div className="layout-data-entry-form__field margintop-lg">
            <label>
                <b>Cash Flow Discount Rate</b>
            </label>
            <span aria-label="Cash Flow Discount Rate">
                {props.interestRate && formatPercentWithTwoDecimals(props.interestRate)}
            </span>
        </div>
    </section>;
}
